import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { VoidSaleSchema } from "./type";
import { pharmacyClient } from "@/connect";
import { SaleStatus } from "@/gen/sales/common_pb";

const apiUrl = import.meta.env.VITE_API_URL as string;

export const getVoidSales = async (
    offset: number,
    limit: number,
): Promise<VoidSaleSchema[]> => {
    try {
        const page = Math.floor(offset / limit) + 1
        
        const response = await pharmacyClient.listSales({
            page,
            pageSize: limit,
            status: SaleStatus.VOIDED,
        });
        
        return response.sales.map((item: any) => VoidSaleSchema.parse(item));
    } catch (error) {
        console.error("Error fetching void sales:", error);
        throw new Error("Failed to fetch void sales");
    }
}